import _extends from "@babel/runtime/helpers/extends";
import { LucideProvider as BaseLucideProvider } from "lucide-react";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function LucideProvider(_ref) {
  var _ref$config = _ref.config,
    config = _ref$config === void 0 ? {
      size: 16
    } : _ref$config,
    children = _ref.children;
  return /*#__PURE__*/_jsx(BaseLucideProvider, _extends({}, config, {
    children: children
  }));
}
export default LucideProvider;